export class UpdateIdpGroupRequest {
    'roleIds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleIds",
            "baseName": "roleIds",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return UpdateIdpGroupRequest.attributeTypeMap;
    }
    constructor() {
    }
}
